export default __webpack_public_path__ + "resources/icons/d142-4bf1.webp";